// extracted by mini-css-extract-plugin
export default {"content":"share-mockup-design-popup__content___DfFOD","orangeBackground":"share-mockup-design-popup__orangeBackground___HHWlD"};